import { useNavigator } from '@repo/toolkit/use-navigator'
import { BusTwoIcon, PlusIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API, constructApiUrl } from '../../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../components/elements/nav-bar'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import useTranslate from '../../../lib/hooks/use-translate'
import { CoachCompany } from '../../../lib/types/models/ol/coach-company/coach-company'
import { getCoachCompaniesColumns } from './util'

const CoachCompaniesListPage = () => {
  const { navigate, navigateWithEvent } = useNavigator()
  const tableRef = useRef<DynamicTableRef<CoachCompany>>(null)
  const { user } = useAuth()
  const { t } = useTranslate()
  const ol = user?.ol

  if (!ol) return <LoadingScreen />

  return (
    <div>
      <UserNavBar title={'Coach company'} icon={BusTwoIcon} />
      <div className={'h-4'} />
      <DynamicDataTable<CoachCompany, null>
        ref={tableRef}
        title={'Coach companies'}
        deleteMessage={{
          attributeName: 'name',
          name: 'coach companies',
          deleteAll: 'Are you sure you want to delete all the coach companies?'
        }}
        columns={getCoachCompaniesColumns(t)}
        selectable
        allowSearchParam
        onRowClick={(activity, event) =>
          navigateWithEvent(
            Paths.OL_PERSONAL_SPACE_COACH_COMPANIES_UPDATE_PAGE.replace(
              ':id',
              activity.id.toString()
            ),
            event
          )
        }
        endpoint={constructApiUrl(API.ols.getCoachCompanies.url, { olId: +ol.id })}
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            variant: 'primary',
            label: t('coach.company.table.add.coach.company'),
            fn: () => navigate(Paths.OL_PERSONAL_SPACE_COACH_COMPANIES_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default CoachCompaniesListPage
